(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["christmas-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => root.querySelectorAll('[data-xmas-finder]:not(.is-ready)').forEach(finder => {
    const tabs = [...finder.querySelectorAll('[role="tab"]')];
    const panels = [...finder.querySelectorAll('[data-xmas-panel]')];
    if (!tabs.length || tabs.length !== panels.length) return;
    const activate = (index, focus = false) => {
      tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; panels[i].setAttribute('role', 'tabpanel'); });
      if (focus) tabs[index].focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(next, true); }
      });
    });
    finder.querySelector('[role="tablist"]').hidden = false;
    finder.classList.add('is-ready');
    activate(0);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true }); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

(() => {
  const initMotion = root => root.querySelectorAll('[data-xmas-house]:not(.motion-ready)').forEach(house => {
    const buttons = house.querySelectorAll('[data-xmas-motion]');
    const hero = house.querySelector('.cg-xmas__hero');
    if (!hero) return;
    const stage = house.querySelector('.cg-xmas__unbox');
    const placeOrigins = () => {
      if (!stage) return;
      const mouthX = stage.clientWidth * .5;
      const mouthY = stage.clientHeight * .72;
      stage.querySelectorAll('.cg-xmas__gift-product').forEach(product => {
        product.style.setProperty('--gift-start-x', (mouthX - product.offsetLeft - product.offsetWidth * .5) + 'px');
        product.style.setProperty('--gift-start-y', (mouthY - product.offsetTop - product.offsetHeight * .85) + 'px');
      });
    };
    placeOrigins();
    if (stage && 'ResizeObserver' in window) {
      const sizeObserver = new ResizeObserver(placeOrigins);
      sizeObserver.observe(stage);
      stage.querySelectorAll('img').forEach(image => { if (!image.complete) image.addEventListener('load', placeOrigins, { once: true }); });
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(house)) sizeObserver.disconnect(); }, { once: true });
    }
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    const setPaused = (paused, manual = false) => {
      house.classList.toggle('is-paused', paused);
      house.classList.toggle('motion-opt-in', manual && !paused);
      buttons.forEach(button => {
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? button.dataset.play : button.dataset.pause;
      });
    };
    setPaused(media.matches);
    house.classList.add('motion-ready');
    buttons.forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => setPaused(!house.classList.contains('is-paused'), true));
    });
    media.addEventListener('change', event => setPaused(event.matches));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('is-away', !entry.isIntersecting)));
      observer.observe(hero);
      const discover = house.querySelector('.cg-xmas__discover');
      if (discover) observer.observe(discover);
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(house)) observer.disconnect(); }, { once: true });
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initMotion(document), { once: true }); else initMotion(document);
  document.addEventListener('shopify:section:load', event => initMotion(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-visual-header"]) return;
  try {
    
  function preserveCollectionView() {
    const header = document.querySelector('[data-cg-collection-view]');
    if (!header) return;
    const view = header.dataset.cgCollectionView;
    const collectionPath = header.dataset.collectionPath;
    document.querySelectorAll('.collection-products .facets-form').forEach(form => {
      form.querySelectorAll('.facets__price input[type="number"]').forEach(input => { input.step = '0.01'; });
      if (!view) return;
      if (form.querySelector('input[name="view"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'view';
      input.value = view;
      form.append(input);
    });
    if (!view) return;
    document.querySelectorAll('.collection-products a[href]').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin || url.pathname.includes('/products/')) return;
      if (url.pathname !== collectionPath && !url.pathname.startsWith(collectionPath + '/')) return;
      url.searchParams.set('view', view);
      link.href = url.pathname + url.search + url.hash;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preserveCollectionView, { once: true });
  } else {
    preserveCollectionView();
  }
  document.addEventListener('shopify:section:load', preserveCollectionView);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  function init(scope) {
    scope.querySelectorAll('[data-hw-motion]').forEach(root => {
      if (root.dataset.motionReady) return;
      root.dataset.motionReady = 'true';
      root.querySelectorAll('[data-scene]').forEach(control => control.addEventListener('click', () => {
        const scene = root.querySelector('[data-night-scene]');
        const night = control.dataset.scene === 'night';
        scene.querySelector('[data-day-image]').hidden = night;
        scene.querySelector('[data-night-image]').hidden = !night;
        scene.querySelectorAll('[data-scene]').forEach(el => el.setAttribute('aria-pressed', String(el === control)));
      }));
      const crewTabs = [...root.querySelectorAll('[data-crew] [role="tab"]')];
      function selectCrew(tab, focus) {
        crewTabs.forEach(el => {
          const active = el === tab;
          el.setAttribute('aria-selected', String(active));
          el.tabIndex = active ? 0 : -1;
          root.querySelector('#' + el.getAttribute('aria-controls')).hidden = !active;
        });
        if (focus) tab.focus();
      }
      crewTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectCrew(tab, false));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % crewTabs.length;
          if (event.key === 'ArrowLeft') next = (index + crewTabs.length - 1) % crewTabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = crewTabs.length - 1;
          if (next !== undefined) { event.preventDefault(); selectCrew(crewTabs[next], true); }
        });
      });
      const button = root.querySelector('.hw-motion-toggle');
      let manuallyPaused = false;
      function update() {
        const paused = manuallyPaused || preference.matches;
        root.dataset.motionPaused = String(paused);
        button.hidden = preference.matches;
        button.setAttribute('aria-pressed', String(paused));
        button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      }
      button.addEventListener('click', () => { manuallyPaused = !manuallyPaused; update(); });
      preference.addEventListener('change', update);
      update();
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          entry.target.classList.toggle('hw-motion-visible', entry.isIntersecting);
        }), {threshold: 0.05});
        root.querySelectorAll('.hw-hero,.hw-editorial').forEach(el => observer.observe(el));
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(root)) { observer.disconnect(); preference.removeEventListener('change', update); }
        });
      }
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-seasonal-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(scope) {
    scope.querySelectorAll('[data-season-tabs]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const status = root.querySelector('[role="status"]');
      let selected = tabs[0];
      function announce(text) { status.textContent = text; }
      async function load(panel, tab) {
        if (!panel.dataset.seasonUrl || panel.dataset.loaded) return;
        if (panel.dataset.loading) { announce('Loading products…'); return; }
        panel.dataset.loading = 'true'; panel.setAttribute('aria-busy', 'true'); announce('Loading products…');
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        try {
          const url = new URL(panel.dataset.seasonUrl, location.origin);
          if (url.origin !== location.origin) throw new Error('Invalid collection');
          url.searchParams.set('section_id', 'home-seasonal-panel');
          const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) throw new Error('Load failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = doc.querySelector('[data-seasonal-source]');
          if (!source) throw new Error('Missing panel');
          const used = new Set([...document.querySelectorAll('main .product-card[data-product-id]')].filter(c => !root.contains(c) && !c.closest('[hidden]')).map(c => c.dataset.productId));
          const cards = [...source.querySelectorAll('.product-card')].filter(c => !used.has(c.dataset.productId)).slice(0, 6);
          cards.forEach(card => {
            card.querySelectorAll('[id]').forEach(el => {
              const oldId = el.id, nextId = panel.id + '-' + oldId;
              card.querySelectorAll('[for]').forEach(label => { if (label.htmlFor === oldId) label.htmlFor = nextId; });
              el.id = nextId;
            });
          });
          panel.replaceChildren(...cards); panel.dataset.loaded = 'true';
          if (selected === tab) announce(cards.length ? '' : 'No products available in this selection.');
          document.dispatchEvent(new CustomEvent('custogifts:content:loaded', {detail:{root:panel}}));
        } catch (error) {
          if (selected === tab) {
            announce('Products could not load.');
            const retry = document.createElement('button'); retry.type = 'button'; retry.textContent = 'Try again';
            retry.addEventListener('click', () => load(panel, tab)); status.append(retry);
          }
        } finally { clearTimeout(timer); delete panel.dataset.loading; panel.removeAttribute('aria-busy'); }
      }
      function select(tab) {
        selected = tab; announce('');
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1;
          root.querySelector('#' + item.getAttribute('aria-controls')).hidden = !active;
        });
        load(root.querySelector('#' + tab.getAttribute('aria-controls')), tab);
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[next].focus(); select(tabs[next]);
        });
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    let frame = 0;
    const mobile = window.matchMedia('(max-width: 989px)');
    const update = () => {
      frame = 0;
      const root = document.querySelector('.main-cart');
      const checkout = root?.querySelector('.cart__actions [name="checkout"]');
      const bar = root?.querySelector('.cart__bar');
      if (!checkout || !bar) return;
      const viewport = window.visualViewport;
      const top = viewport?.offsetTop || 0;
      let bottom = top + (viewport?.height || window.innerHeight);
      const preview = document.getElementById('PBarNextFrame');
      const previewRect = preview?.getBoundingClientRect();
      if (previewRect?.height && previewRect.top > top && previewRect.top < bottom) bottom = previewRect.top;
      const rect = checkout.getBoundingClientRect();
      const visible = rect.height > 0 && rect.top >= top && rect.bottom <= bottom;
      bar.hidden = !mobile.matches || visible;
      bar.style.bottom = `${Math.max(0, window.innerHeight - bottom)}px`;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule);
    window.visualViewport?.addEventListener('resize', schedule);
    window.visualViewport?.addEventListener('scroll', schedule);
    document.addEventListener('shopify:section:load', schedule);
    const root = document.querySelector('.main-cart');
    if (root && 'ResizeObserver' in window) new ResizeObserver(schedule).observe(root);
    new MutationObserver(schedule).observe(document.body, { childList: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  function initializeCollectionSort() {
    document.querySelectorAll('.collection-products .facets-form--sort-only').forEach(form => form.classList.add('facets-form--auto-sort'));
  }
  initializeCollectionSort();
  document.addEventListener('shopify:section:load', initializeCollectionSort);
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (select instanceof HTMLSelectElement && select.matches('.collection-products .facets-form__sort select')) {
      select.form?.requestSubmit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cg-newsletter')) {
    customElements.define('cg-newsletter', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        if (!this.form || !window.fetch) return;
        if (this.form.hasAttribute('data-hcaptcha-bound')) return;
        this.message = this.querySelector('[data-newsletter-result]');
        this.button = this.form.querySelector('button[type="submit"]');
        this.email = this.form.querySelector('input[type="email"]');
        this.label = this.button.textContent;
        const nativeSubmit = HTMLFormElement.prototype.submit.bind(this.form);
        this.form.submit = () => {
          if (this.nativeNext) { nativeSubmit(); return; }
          if (!this.pending) this.send();
        };
        this.form.addEventListener('submit', (event) => {
          if (this.pending || this.protecting) { event.preventDefault(); event.stopImmediatePropagation(); return; }
          if (event.defaultPrevented || this.nativeNext) return;
          if (this.form.hasAttribute('data-hcaptcha-bound')) return;
          event.preventDefault();
          if (!this.form.reportValidity()) return;
          if (window.Shopify?.captcha?.protect) {
            this.protecting = true;
            const release = setTimeout(() => { this.protecting = false; }, 20000);
            window.Shopify.captcha.protect(this.form, () => {
              clearTimeout(release);
              this.protecting = false;
              this.form.submit();
            });
          } else {
            this.form.submit();
          }
        });
      }

      async send() {
        this.pending = true;
        this.form.setAttribute('aria-busy', 'true');
        this.message.hidden = true;
        this.email.removeAttribute('aria-invalid');
        const data = new URLSearchParams(new FormData(this.form));
        this.button.disabled = true;
        this.button.textContent = this.dataset.loading;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch(this.form.action, {
            method: 'POST', body: data, credentials: 'same-origin',
            headers: { Accept: 'text/html' }, signal: controller.signal
          });
          const destination = new URL(response.url);
          if (destination.origin !== location.origin) throw new Error('Unexpected response origin');
          if (destination.pathname.replace(/\/$/, '') === '/challenge') {
            location.assign(destination.href);
            return;
          }
          if (!response.ok) throw new Error('Signup could not be confirmed');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = page.getElementById(this.form.id)?.querySelector('[data-newsletter-result]');
          if (result?.dataset.newsletterResult === 'success') {
            this.message.replaceChildren(...Array.from(result.childNodes, (node) => document.importNode(node, true)));
            this.message.dataset.newsletterResult = 'success';
            this.message.className = 'form-message form-message--success';
            this.message.hidden = false;
            this.form.querySelector('.newsletter-form__field').hidden = true;
            this.message.focus({ preventScroll: true });
          } else if (result?.dataset.newsletterResult === 'error') {
            this.showError(result.textContent.trim());
            this.email.setAttribute('aria-invalid', 'true');
          } else {
            this.nativeNext = true;
            throw new Error('Native verification required');
          }
        } catch {
          this.showError(this.dataset.error);
        } finally {
          clearTimeout(timeout);
          this.pending = false;
          this.form.removeAttribute('aria-busy');
          this.button.disabled = false;
          this.button.textContent = this.label;
        }
      }

      showError(text) {
        this.message.textContent = text;
        this.message.dataset.newsletterResult = 'error';
        this.message.className = 'form-message form-message--error';
        this.message.hidden = false;
        this.message.focus({ preventScroll: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
